/*
 * DRIVLY-UI React Components
 * @license MIT
 */
function e(e){let n=[],t=[],s=0,c=!1,l=!1;const o=new WeakSet,r={schedule:(e,l=!1,r=!1)=>{const d=r&&c,h=d?n:t;return l&&o.add(e),-1===h.indexOf(e)&&(h.push(e),d&&c&&(s=n.length)),e},cancel:e=>{const n=t.indexOf(e);-1!==n&&t.splice(n,1),o.delete(e)},process:d=>{if(c)l=!0;else{if(c=!0,[n,t]=[t,n],t.length=0,s=n.length,s)for(let t=0;t<s;t++){const s=n[t];s(d),o.has(s)&&(r.schedule(s),e())}c=!1,l&&(l=!1,r.process(d))}}};return r}export{e as createRenderStep};
//# sourceMappingURL=create-render-step.js.map
